const Tooltip = () => import('@/ChatUI/packages/tooltip/components/DirectiveTooltip.vue');
import Vue from 'vue'
export default class TooltipManager {
  static instance = null
  tooltipInstance = null
  currentTarget = null

  static getInstance() {
    if (!TooltipManager.instance) {
      TooltipManager.instance = new TooltipManager();
    }
    return TooltipManager.instance;
  }

  createTooltip(el) {
    const data = el.binding_value || {}
    if (data.disable) return
    if (this.tooltipInstance?.$el) {
      this.destroyTooltip(this.currentTarget)
    }
    this.currentTarget = el
    const targetRect = el.getBoundingClientRect();
    const targetRectObject = {
      x: targetRect.x,
      y: targetRect.y,
      width: targetRect.width,
      height: targetRect.height,
      top: targetRect.top,
      right: targetRect.right,
      bottom: targetRect.bottom,
      left: targetRect.left
    }
    const DirectiveTooltip = new Vue({
      render: h => h(Tooltip, {
        props: {
          target_el: el,
          targetRect: targetRectObject,
          tooltipData: this.tooltipData,
          placement: data.placement,
          popperClass: data.popperClass,
          text: data.text || '',
          pointer: data.pointer,
          autoEllipsis: data.autoEllipsis,
        },
      })
    });
  
  
    // 手动挂载组件到 DOM 中
    DirectiveTooltip.$mount();
    if (data.insertAfter) {
      this.currentTarget.parentNode.appendChild(DirectiveTooltip.$el)
    } else {
      document.body.appendChild(DirectiveTooltip.$el);
    }
  
    // 返回 Tooltip 组件实例
    this.tooltipInstance = DirectiveTooltip
  }

  updateTooltip(el) {
    if (el !== this.currentTarget) return
    const data = el.binding_value || {}
    const tooltipComponent = this.tooltipInstance?.$children[0];
    if (tooltipComponent) {
      tooltipComponent.updateText(data.text)
    }
    if (data.disable && tooltipComponent) {
      TooltipManager.getInstance().destroyTooltip(el);
    }
  }

  destroyTooltip(el) {
    if (el !== this.currentTarget) return
    if (this.tooltipInstance) {
      this.tooltipInstance.$el.remove()
      this.tooltipInstance.$destroy()
      this.tooltipInstance = null
      this.currentTarget = null
    }
  }
}

export const tooltipDirective = {
  bind(el, binding) {
    el.binding_value = binding.value
    var enterListener = function(event) {
      if (event.currentTarget !== el) return;
      TooltipManager.getInstance().createTooltip(el);
    };

    var leaveListener = function(event) {
      if (event.currentTarget !== el) return;
      TooltipManager.getInstance().destroyTooltip(el);
    };

    el.addEventListener('mouseenter', enterListener);
    el.addEventListener('mouseleave', leaveListener);

    function unbindDirective() {
      el.removeEventListener('mouseenter', enterListener);
      el.removeEventListener('mouseleave', leaveListener);
      TooltipManager.getInstance().destroyTooltip(el);
      el.unbindDirective = null
      el.binding_value = null
    }

    el.unbindDirective = unbindDirective;
  },

  update(el, binding) {
    const instance = TooltipManager.getInstance()
    el.binding_value = binding.value
    if (instance.tooltipInstance) {
      instance.updateTooltip(el);
    }
  },

  unbind(el) {
    el.unbindDirective?.();
  }
}